type Props = {
  value: string;
  label: string;
  iconUrl: string | undefined;
}

export const CollateralOption: React.FC<Props> = (props) => {
  return (
    <div className='flex flex-row'>
      <img src={props.iconUrl} alt={props.label} className="w-6 h-6"/>
      <span className='ml-3'>{props.label}</span>
    </div>
  );
};